import { BusinessType, Plan, RecommendedPricing } from "../types"
import { useState } from "react"
import { useIntl } from "react-intl"

const chargingPolicyPerVisitor = {
  [BusinessType.COMMERCE]: {
    minimum: 1,
    maximum: 2,
  },
  [BusinessType.EDUCATION]: {
    minimum: 0.5,
    maximum: 1,
  },
  [BusinessType.SOCIAL_MEDIA]: {
    minimum: 2,
    maximum: 4,
  },
  [BusinessType.ETC]: {
    minimum: 1,
    maximum: 2,
  },
}
const defaultPricing = {
  plan: Plan.FREE,
  monthlyExpectedPrice: {
    minimum: 0,
    maximum: 0,
  },
  monthlyExpectedEvent: {
    minimum: 0,
    maximum: 0,
  },
}
export default function usePricing() {
  const [visitor, setVisitor] = useState(10000)
  const [recommendedPricing, setRecommendedPricing] = useState<RecommendedPricing>(defaultPricing)
  const intl = useIntl()
  const categories = [
    { type: BusinessType.COMMERCE, text: intl.formatMessage({ id: "pricing_calculator_business_type_commerce" }) },
    {
      type: BusinessType.SOCIAL_MEDIA,
      text: intl.formatMessage({ id: "pricing_calculator_business_type_social_media" }),
    },
    { type: BusinessType.EDUCATION, text: intl.formatMessage({ id: "pricing_calculator_business_type_education" }) },
    { type: BusinessType.ETC, text: intl.formatMessage({ id: "pricing_calculator_business_type_others" }) },
  ]

  function onChangeCalculating(businessType: BusinessType, mauAmount: number) {
    setRecommendedPricing(calculatePrice(businessType, mauAmount))
    setVisitor(mauAmount)
  }

  function calculatePrice(businessType: BusinessType, mauAmount: number): RecommendedPricing {
    const minimum = chargingPolicyPerVisitor[businessType].minimum * mauAmount
    const maximum = chargingPolicyPerVisitor[businessType].maximum * mauAmount
    const plan = (() => {
      if (minimum <= 10_000) return Plan.FREE
      if (1_000_000 < minimum) return Plan.ENTERPRISE
      return Plan.PRO
    })()
    if (plan === Plan.FREE) {
      return {
        ...defaultPricing,
        monthlyExpectedEvent: {
          minimum: minimum * 10,
          maximum: maximum * 10,
        },
      }
    }

    return {
      plan,
      monthlyExpectedPrice: {
        minimum,
        maximum,
      },
      monthlyExpectedEvent: {
        minimum: minimum * 10,
        maximum: maximum * 10,
      },
    }
  }
  return {
    visitor,
    categories,
    calculate: calculatePrice,
    onChangeCalculating,
    recommendedPricing,
  }
}
